import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { FiX } from "react-icons/fi";

export default function MediaModal({ item, onClose }) {
  useEffect(() => {
    if (!item) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [item, onClose]);

  if (!item) {
    return null;
  }

  return createPortal(
    <div
      className="media-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="media-modal-title"
      onClick={onClose}
    >
      <div className="media-modal__dialog" onClick={(event) => event.stopPropagation()}>
        <button
          type="button"
          className="media-modal__close"
          onClick={onClose}
          aria-label="Close image preview"
        >
          <FiX aria-hidden="true" />
        </button>

        <div className="media-modal__image-wrap">
          <img src={item.image} alt={item.name} className="media-modal__image" />
        </div>

        <div className="media-modal__content">
          <p className="eyebrow">Bagasse products</p>
          <h2 id="media-modal-title">{item.name}</h2>
          <p>{item.description}</p>
        </div>
      </div>
    </div>,
    document.body
  );
}
